<template>
    <div class="card">
        <div class="card-header">Update Employer(s)</div>
        <div class="card-body">
            <div v-for="(employer, index) in application.employers" :key="employer.employerId">
                <b-row>
                    <b-col cols="12" lg="4">
                        <EmployerAutosuggestInput v-model="employer.name"
                                                  :v="$v.application.employers.$each[index].name"
                                                  slug="name"
                                                  label="Employer/ Establishment Name"
                                                  :key="index"
                                                  v-on:employer="updateEmployer($event, index)"
                                                  :setId="'name'+index"
                                                  :plaintext="employer.employerId != null"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextInput v-model="employer.streetAddress"
                                       :v="$v.application.employers.$each[index].streetAddress"
                                       slug="streetAddress"
                                       label="Street Address"
                                       :key="index"
                                       :setId="'streetAddress'+index"
                                       :plaintext="employer.employerId != null"
                        />
                    </b-col>
                    <b-col cols="12" lg="3">
                        <BaseTextInput v-model="employer.city"
                                       :v="$v.application.employers.$each[index].city"
                                       slug="city"
                                       label="City"
                                       :key="index"
                                       :setId="'city'+index"
                                       :plaintext="employer.employerId != null"
                        />
                    </b-col>
                    <b-col cols="12" lg="3">
                        <BaseSelector v-model="employer.state"
                                      :v="$v.application.employers.$each[index].state"
                                      label="State"
                                      slug="state"
                                      :options=opts.stateOptions
                                      :key="index"
                                      :setId="'state'+index"
                                      :plaintext="employer.employerId != null"
                        />
                    </b-col>
                    <b-col cols="12" lg="2">
                        <BaseMaskedTextInput v-model="employer.postalCode"
                                             :v="$v.application.employers.$each[index].postalCode"
                                             slug="postalCode"
                                             label="ZIP"
                                             :key="index"
                                             :setId="'postalCode'+index"
                                             mask="#####-####"
                                             :plaintext="employer.employerId != null"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" lg="6">
                        <BaseMaskedTextInput v-model="employer.phone"
                                             :v="$v.application.employers.$each[index].phone"
                                             slug="phone"
                                             label="Phone"
                                             :key="index"
                                             :setId="'phone'+index"
                                             mask="(###)###-####"
                                             :plaintext="employer.employerId != null"
                        />
                    </b-col>
                    <b-col cols="12" lg="6">
                        <BaseTextInput v-model="employer.emailAddress"
                                       :v="$v.application.employers.$each[index].emailAddress"
                                       slug="emailAddress"
                                       label="Email Address"
                                       :key="index"
                                       :setId="'emailAddress'+index"
                                       :plaintext="employer.employerId != null"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseDateInput v-model="employer.startDate"
                                       :v="$v.application.employers.$each[index].startDate"
                                       label="Start Date"
                                       slug="startDate"
                                       :key="index"
                                       :setId="'startDate'+index"
                                       :messages="opts.startDateMessages"
                                       :plaintext="employer.employerId != null"
                        />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseDateInput v-model="employer.endDate"
                                       :v="$v.application.employers.$each[index].endDate"
                                       label="End Date"
                                       slug="endDate"
                                       :key="index"
                                       tip="If you are currently working at this location please leave the end date blank"
                                       :setId="'endDate'+index"
                                       :messages="opts.endDateMessages"
                                       :plaintext="employer.employerId != null && oldEmp[index] != null"
                        />
                    </b-col>
                </b-row>
            </div>
            <b-row>
                <b-col cols="2">
                    <button class="btn btn-secondary" @click="addEmployer">
                        Add Another Employer
                    </button>
                </b-col>
                <b-col cols="2">
                    <button class="btn btn-primary" @click="onSubmit">
                        Update
                    </button>
                </b-col>
            </b-row>
        </div>
    </div>

</template>
<script>
    import BaseTextInput from '@/components/templates/input/BaseTextInput.vue'
    import BaseMaskedTextInput from '@/components/templates/input/BaseMaskedTextInput.vue'
    import BaseSelector from '@/components/templates/input/BaseSelector.vue'
    import BaseDateInput from '@/components/templates/input/BaseDateInput.vue'
    import EmployerAutosuggestInput from '@/components/templates/input/EmployerAutosuggestInput.vue'
    import { commonOptions } from '@/mixins/commonOptions.js'
    import { required, requiredIf, minLength, maxLength, email } from 'vuelidate/lib/validators'
    import minDate from '@/validators/minDate'
    import maxDate from '@/validators/maxDate'
    import axiosRetry from 'axios-retry'
    import axios from "axios"

    export default {
        props: {
            application: {
                type: Object,
                default () {
                    return {
                        employers: [{
                            employerId : null,
                            applicatonId: null,
                            name: null,
                            streetAddress: null,
                            city: null,
                            state: null,
                            postalCode: null,
                            phone: null,
                            emailAddress: null,
                            startDate: null,
                            endDate: null
                        }],
                    }
                }
            },
            oldEmp: [Array]
        },

        data: () => {
            return {
                opts: {
                    startDateMessages: {
                        minDate: 'Start Date must be after 01/01/1900.',
                        maxDate: 'Start Date can not be in the future.'
                    },
                    endDateMessages: {
                        minDate: 'End Date must be after Start Date',
                        maxDate: 'End Date can not be in the future.'
                    }
                }
            }
        },
        mixins: [
            commonOptions
        ],
        components: {
            BaseTextInput,
            BaseSelector,
            BaseMaskedTextInput,
            BaseDateInput,
            EmployerAutosuggestInput
        },
        validations() {
            return {
                application: {
                    employers: {
                        required,
                        $each: {
                            employerId : { required: false },
                            applicatonId: { required: false },
                            name: { required },
                            streetAddress: { required },
                            city: { required },
                            state: { required },
                            postalCode: {
                                required,
                                maxLength: maxLength(10), minLength: minLength(5)
                            },
                            phone: {
                                required,
                                minLength: minLength(13)
                            },
                            emailAddress: {
                                required,
                                email
                            },
                            startDate: { required,
                                minDate: minDate(new Date('1900-01-01')),
                                maxDate: maxDate(new Date())
                            },
                            endDate: { required: false,
                                maxDate: maxDate(new Date()),
                                minDate: minDate(">")
                            }
                        }
                    }
                },
                form: [ 'application' ]
            }
        },
        methods: {
            addEmployer: function () {
                this.application.employers.push({
                    employerId : null,
                    applicatonId: null,
                    name: null,
                    streetAddress: null,
                    city: null,
                    state: null,
                    postalCode: null,
                    phone: null,
                    emailAddress: null,
                    startDate: null,
                    endDate: null
                });
            },
            validate() {
                this.$v.form.$touch();
                var isValid = !this.$v.form.$invalid
                this.$emit('on-validate', 'e', this.$data, isValid)
                return isValid
            },
            onSubmit() {
                this.validate()
                if (!this.$v.form.$invalid) {
                    var submitting = Object.assign({}, this.application, this.$data)
                    axiosRetry(axios, { retries: 0 })
                    axios.post(`${process.env.VUE_APP_API_BASE_URL}/contact/employer/` + this.application.applicationId, submitting)
                        .then(response => {
                            this.showRootToast("Employer Updates", "The employer history has been updated.", "success")
                        }) .catch(error => {
                        console.log(error)
                        this.showRootToast("Error", "An error has occurred " , "danger")
                    })
                }
            },
            showRootToast(title, message, type) {
                this.$root.$bvToast.toast(message, {
                    title: title,
                    toaster: 'b-toaster-top-center',
                    solid: true,
                    variant: type,
                    appendToast: true,
                    noAutoHide:true
                })
                this.toastFocus()
            },
            toastFocus() {
                setTimeout(() => {
                    let elem = document.getElementsByClassName("toast")
                    elem = elem[elem.length-1]
                    elem.focus()
                }, 100)
            },
            updateEmployer(values, idx) {
                //set values
                this.application.employers[idx].name = values.name

                document.getElementById('name'+idx).value = values.name;
                document.getElementById('streetAddress'+idx).value = values.streetAddress;
                document.getElementById('city'+idx).value = values.city;
                document.getElementById('state'+idx).value = values.state;
                document.getElementById('postalCode'+idx).value = values.postalCode;
                document.getElementById('phone'+idx).value = values.phone;
                document.getElementById('emailAddress'+idx).value = values.emailAddress;
                document.getElementById('startDate'+idx).value = values.startDate;
                document.getElementById('endDate'+idx).value = values.endDate;

                //send change event
                document.getElementById('name'+idx).dispatchEvent(new Event('change'));
                document.getElementById('streetAddress'+idx).dispatchEvent(new Event('change'));
                document.getElementById('city'+idx).dispatchEvent(new Event('change'));
                document.getElementById('state'+idx).dispatchEvent(new Event('change'));
                document.getElementById('postalCode'+idx).dispatchEvent(new Event('change'));
                document.getElementById('phone'+idx).dispatchEvent(new Event('change'));
                document.getElementById('emailAddress'+idx).dispatchEvent(new Event('change'));
                document.getElementById('startDate'+idx).dispatchEvent(new Event('change'));
                document.getElementById('endDate'+idx).dispatchEvent(new Event('change'));
            },
        }
    }
</script>
